export default {


    /**
     * Set cover
     * @param commit
     * @param name
     * @param val
     * @param title
     * @returns {*|Promise|Promise<any>}
     */
    var({ commit }, {name, val}) {
        commit("SET_VAR", {name, val});
    },

}
